// extracted by mini-css-extract-plugin
export default {"overlay":"popover_overlay__XxTp3","popover":"popover_popover__GOu4a","fadeInAnimation":"popover_fadeInAnimation__mHDgg"};